import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormlyFieldConfig } from 'ng-formly';
//import 'ag-grid-enterprise/main';
import { LoopBackFilter, Entityrecord } from '../../../sdk/models';
import { EntityApi, EntityfieldApi, EntityrecordApi } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { EntityService } from '../../../services/entity.service';
import { ValidationService } from '../../../services/validation.service';
import { GridUtilities } from '../../../components/grid/GridUtilities';
import { CacheService, CacheStoragesEnum } from 'ng2-cache/ng2-cache';
import { PlatformApp } from '../../../services/app.service';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'display-list-widget',
    templateUrl: './display-list.component.html',
    providers: [EntityApi, EntityfieldApi, EntityrecordApi, EntityService, NotificationsService, PushNotificationsService],
    styleUrls: ['./display-list.component.scss']
})

export class DisplayListComponent implements OnInit, OnDestroy {
    @Input() entitytype: string;
    @Input() inputentityid: string;
    @Input() hidetopbuttons: string;
    @Input() searchlayoutid: string;
    @Input() filteroptions: Object;
    @Input() usecache: string = "true";
    @Input() showaddfilter = "true";
    @Input() parentId;

    showError = false;
    subscriptions: any = [];
    entityid: any;
    entity: any;
    entityRecord: any = {};
    entityname = '';
    rowData: any;
    geoFieldName: any;
    columnDefs: any;
    entityDataFields: any;
    records: any;
    currentuser: any;
    formfields: any = [];
    entityDataColumns: any;
    entityrecordid: any = '';
    entityrecordname: any = '';
    topbuttonsOn = true;
    refreshtime;
    notifyOptions = PlatformApp.getNotificationOptions();

    // Form Related
    initialFormData: any;
    formErrors = [];
    formValid = false;
    options: any = {};

    //filter options
    lookupmap: any;
    /****Formly ***/
    form: FormGroup;
    // form: FormGroup;
    author;
    env;

    public events: any[] = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    entityFormFieldsString: string = '';
    filterRecord = {};
    filterRecords: any = [];
    filterRecordsString: string = '';
    filterChanged: boolean = false;
    recordFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
    public status = { isopen: false };

    /****************Modals************************* */
    @ViewChild('newModal') public newModal: ModalDirective;
    @ViewChild('editModal') public editModal: ModalDirective;
    // @ViewChild('peekModal') public peekModal: ModalDirective;
    @ViewChild('confirmModal') public confirmModal: ModalDirective;

    constructor(private route: ActivatedRoute, private fb: FormBuilder, private _EntityApi: EntityApi, private _EntityfieldApi: EntityfieldApi,
        private _EntityrecordApi: EntityrecordApi,
        private _NotificationsService: NotificationsService, private _LoopBackAuth: LoopBackAuth, private _CacheService: CacheService) {
    }

    ngOnInit(): void {
        this.topbuttonsOn = !(this.hidetopbuttons === 'true');
        this._CacheService.useStorage(CacheStoragesEnum.MEMORY);

        this.form = this.fb.group({});
        this.currentuser = this._LoopBackAuth.getCurrentUserData();

        //!Important -- Set the appId in the entityrecord as it is used for some dropdown
        this.entityRecord.appId = this.currentuser.appId;
        // let focusedcell = this.gridOptions.api.getFocusedCell();
        // if (target.className === 'icon-info') {
        //     this.showPeekModal(item.data);
        // } else if (target.className === 'icon-eye') {
        //     this.router.navigate(['/detail/' + this.entity.id + '/' + item.data.id]);
        // } else if (target.className === 'icon-pencil') {
        //     this.showEditModal(item.data);
        // } else if (target.className === 'fa fa-trash-o') {
        //     this.confirmDelete(item.data);
        // }

        this.subscriptions.push(this.route.params.subscribe(params => {
            this.entitytype = params['entitytype']; // (+) converts string 'id' to a number
            this.refreshData();
        }));
    }



    onFilterChanged(records) {
        this.filterRecords = records;
        this.filterRecordsString = JSON.stringify(this.filterRecords);
        this.filterChanged = true;
        this.refreshData();
    }

    ngOnChanges(change) {
        if (change && change.entitytype && !change.entitytype.firstChange && (change.entitytype.previousValue !== change.entitytype.currentValue)) {
            this.hideEditModal();
            this.hideNewModal();
            //Clear the quickfilter text
            if (this.filterRecords && this.filterRecords.length && this.filterRecords.length > 0)
                this.filterChanged = true;
            this.filterRecords = [];
            this.filterRecordsString = JSON.stringify(this.filterRecords);

        }
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    confirmDelete(entityrecord) {
        this.entityRecord = entityrecord;
        if (!this.entityrecordid || (entityrecord.id && this.entityrecordid !== entityrecord.id))
            this.entityrecordid = entityrecord.id;
        this.confirmModal.show();
    }

    deleteRecord(entityrecord?): void {
        this.confirmModal.hide();
        if (!this.entityrecordid || (this.entityRecord.id && this.entityRecord.id !== this.entityrecordid))
            this.entityrecordid = this.entityRecord.id;

        let eid = this.entityrecordid;
        if (!eid && entityrecord) { eid = entityrecord.id; }

        this.subscriptions.push(this._EntityrecordApi.deleteById(eid)
            .subscribe((result) => {
                if (result && result['count'] && result['count'] === 1) {
                    this.notify('success', 'Deleted ' + this.entity.label, eid);
                    let index = _.indexOf(this.records, _.find(this.records, { 'id': eid }));
                    if (index > -1) {
                        this.records.splice(index, 1);
                    }
                    if (this.usecache === 'true') {
                        let entitydetails = this._CacheService.get(this.entitytype + '_records');
                        entitydetails.records = this.records;
                        //Insert new record into the cache
                        this._CacheService.set(this.entitytype + '_records', entitydetails);
                    }
                    this.hideEditModal();
                    this.refreshData();
                } else {
                    this.notify('error', 'Delete ' + this.entity.label, JSON.stringify(result));
                }
            }));
    }

    resetFormData(): void {
        if (this.initialFormData)
            this.options.resetModel(this.initialFormData);
        else
            this.options.resetModel({});
    }

    submitRecord(entityRecord): void {
        this.formErrors = [];
        this.formValid = true;
        this.subscriptions.push(this._EntityfieldApi.validateRecord(entityRecord, this.entityid)
            .subscribe((result) => {
                if (result && result.response && result.response.length > 0) {
                    this.formValid = false;
                    this.formErrors = result.response;
                    for (let i = 0; i < this.formErrors.length; i++) {
                        let errorField = this.formErrors[i].field;
                        let errorKey = this.formErrors[i].error;
                        let error = {};
                        error[errorKey] = true;
                        if (this.form.controls[errorField] && typeof this.form.controls[errorField].markAsTouched === 'function') {
                            this.form.controls[errorField].markAsTouched();
                        }
                        this.form.controls[errorField].setErrors(error);
                    }
                }
                if (this.formValid) {
                    this.patchOrCreateEntity();
                } else {
                    this.notify('error', 'Invalid Data', 'Please Correct & Submit');
                }
            }));
    }

    patchOrCreateEntity(): void {

        // Save or Create Entity Record
        let entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = this.entityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (let i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                let dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null);
                if (dateStr)
                    entityRecordforSave.data[this.entityDataFields[i].name] = dateStr;
            }
        }

        if (!this.entityrecordid) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;
            entityRecordforSave.appId = this.currentuser.appId;

            this.subscriptions.push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
                .subscribe((newrecord: Entityrecord) => {
                    this.entityRecord = newrecord;
                    this.appendupdatedrecord(newrecord.id, 'add');

                }));
        } else {
            this.subscriptions.push(this._EntityrecordApi.patchAttributes(this.entityrecordid, entityRecordforSave)
                .subscribe((updatedrecord: Entityrecord) => {
                    this.entityRecord = updatedrecord;
                    this.appendupdatedrecord(updatedrecord.id, 'edit');
                }));
        }
    }


    appendupdatedrecord(entityrecordid, updatetype) {
        //Get the processed record and append it to the grid list
        this.subscriptions.push(this._EntityrecordApi.findByIdProcessed(entityrecordid)
            .subscribe((newrecord) => {
                newrecord = newrecord["response"];
                // this.refreshData(false);
                var label = newrecord.id;
                if (newrecord.data && newrecord.data.name) {
                    label = newrecord.data.name;
                }

                if (updatetype === 'add') {
                    this.notify('success', 'Created ' + this.entity.label, label);
                    this.records.push(newrecord);
                    this.hideNewModal();
                } else if (updatetype === 'edit') {
                    this.notify('success', 'Updated ' + this.entity.label, label);
                    let index = _.indexOf(this.records, { id: newrecord.id });
                    this.records.splice(index, 1, newrecord);
                    this.hideEditModal();
                }

                if (this.usecache === 'true') {
                    let entitydetails = this._CacheService.get(this.entitytype + '_records');
                    entitydetails.records = this.records;
                    //Insert new record into the cache
                    this._CacheService.set(this.entitytype + '_records', entitydetails);
                }
                this.refreshData();
            }));
    }

    reloadData(): void {
        this.hideEditModal();
        this.hideNewModal();
        this._CacheService.remove(this.entitytype + '_records');
        this.refreshData();
    }

    refreshData(): void {

        //If the records are there in the cache , just show them
        if (this.usecache === 'true' && this._CacheService.exists(this.entitytype + '_records') && !this.filterChanged) {
            this.handleresponse(this._CacheService.get(this.entitytype + '_records'));
            return;
        }
        /*
         Entity is identified using the name of the entity - This helps us to get the entity details across the apptype 
         and the specific appId
         1) Get the definition of the entity 
         2) Get the fields and records for the entity 
         3) Get the lookups and picklists for the fields. This is used for the field edits.

        */

        // Grid list works both for entity id as well as entitytype
        let entityFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };

        entityFilter.where['appId'] = this.currentuser.appId;
        if (this.inputentityid)
            entityFilter.where['id'] = this.inputentityid;
        if (this.entitytype)
            entityFilter.where['name'] = this.entitytype;
        this.filterChanged = false;

        //Clean up filterRecords
        let recordFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
        // if (this.filterRecords && this.filterRecords.length && this.filterRecords.length > 0) {
        //     this.filterRecords.forEach(filterRecord => {
        //         let filter = {};
        //         filter['filterfield'] = filterRecord.filterfield;
        //         filter['filtercondition'] = filterRecord.filtercondition;
        //         filter['filtervalue'] = filterRecord.filtervalue;
        //         filter['filterValueType'] = filterRecord.filterValueType;
        //         filters.push(filter);
        //     });
        // }

        this.subscriptions.push(this._EntityApi.getRecordsforEntity(entityFilter, recordFilter)
            .subscribe((data) => {
                if (data && data.response && data.response.status && data.response.status === 'ok') {
                    let details = data.response;
                    details.refreshtime = new Date();
                    this.notify('info', details.records.length + ' ' + details.entity.plural_label, 'Loaded @ ' + details.refreshtime.toLocaleTimeString());
                    if (this.usecache === 'true') {
                        if (this.filterRecords && this.filterRecords.length && this.filterRecords.length > 0)
                            details.filters = this.filterRecords;
                        this._CacheService.set(this.entitytype + '_records', details);
                    }
                    this.handleresponse(details);
                } else {
                    this.clearupdetails();
                    this.notify('error', 'Entity', 'Not Loaded');
                }
            }));
    }

    clearupdetails() {
        this.showError = true;
        delete this.entity;
        delete this.entityid;
        delete this.records;
        delete this.filterRecords;
        delete this.filterRecordsString;
        delete this.entityFormFields;
        delete this.entityDataFields;
        delete this.entityDataColumns;
        //Cleanup cache
        this._CacheService.remove('formfields');
        this._CacheService.remove(this.entitytype + '_records');
    }

    handleresponse(details) {
        this.entity = details.entity;
        this.entityid = details.entity.id;
        this.records = details.records;
        this.filterRecords = details.filters;
        this.filterRecordsString = JSON.stringify(this.filterRecords);
        this.entityFormFields = details['formfields'];
        this.entityFormFieldsString = JSON.stringify(details['formFields']);
        this.entityDataFields = details['datafields'];
        this.entityDataColumns = this.setsearchlayout(details['datacolumns'], details['searchlayouts']);
        this.lookupmap = details.lookupmap;
        this.refreshtime = details.refreshtime;
        //Set the fields in cache
        this._CacheService.set('formfields', this.entityFormFields);
    }

    setsearchlayout(datacolumns, searchlayouts) {
        let fields;
        let defaultSortField;
        let defaultSortType;
        let searchLayout;
        if (searchlayouts && searchlayouts.length && searchlayouts.length > 0) {
            if (this.searchlayoutid) {
                var searchl = _.find(searchlayouts, { id: this.searchlayoutid })
                if (searchl) {
                    searchLayout = searchl;
                }
            } else {
                searchLayout = searchlayouts[0];
            }

        }
        if (searchLayout) {
            fields = searchlayouts[0].fields;
        }
        if (searchLayout && searchLayout.defaultsort && searchLayout.defaultsort[0]) {
            defaultSortField = searchLayout.defaultsort[0];
        }
        if (searchLayout && searchLayout.defaultsorttype) {
            defaultSortType = searchLayout.defaultsorttype;
        }
        //Leave out the first 2 fields as they are the edit icons
        for (let i = 0; i < datacolumns.length; i++) {
            //Check if this column is present in the default layout fields
            if (datacolumns[i].headerName) {
                if (fields) {
                    let index = _.indexOf(fields, datacolumns[i].id);
                    if (index > -1) {
                        datacolumns[i].hide = false;
                    } else {
                        datacolumns[i].hide = true;
                    }
                }
                if (defaultSortField && defaultSortType && defaultSortField === datacolumns[i].id) {
                    datacolumns[i].sort = defaultSortType;
                }

                //Add the proper Comparator for Currency fields
                if (datacolumns[i].fieldtype === 'currency') {
                    datacolumns[i].comparator = GridUtilities.numberComparator;
                }

                if (this.checkforDateColumn(datacolumns[i])) {
                    datacolumns[i].comparator = GridUtilities.dateComparator;
                    datacolumns[i].cellRenderer = GridUtilities.dateRenderer;
                }
                //Finally delete the datacolumn if it is a repeatedsection
                if (datacolumns[i].fieldtype === 'repeatedsection') {
                    delete datacolumns[i];
                }
            }
        }

        return datacolumns;
    }

    checkforDateColumn(column) {
        if (column.fieldtype === 'dateandtime' || column.fieldtype === 'date') {
            return true;
        } else {
            return false;
        }
    }

    resetForm(): void {
        if (this.form && this.form['subscriptions']) {
            this.form['subscriptions'].forEach(s => { s.unsubscribe(); });
        }
        this.form = this.fb.group({});
        this.form['subscriptions'] = [];
    }

    public showNewModal(): void {
        this.entityRecord = {};
        if (this.parentId) {
            this.entityRecord['parentId'] = this.parentId;
        }
        this.entityrecordid = null;
        this.formfields = _.cloneDeep(this.entityFormFields);
        this.initialFormData = _.cloneDeep(this.entityRecord);
        this.populateformfields();
        this.newModal.show();
    }

    public hideNewModal(): void {
        this.resetForm();
        this.newModal.hide();
    }

    public showEditModal(selectedEntityRecord): void {
        this.subscriptions.push(this._EntityrecordApi.findByIdforEdit(selectedEntityRecord.id)
            .subscribe((record) => {
                if (record && record['response']) {
                    if (record['response']['record'] && record['response']['record']['data']) {
                        this.entityRecord = _.cloneDeep(record['response']['record']['data']);
                    } else {
                        this.entityRecord = {};
                    }
                    if (record['response']['formfields']) {
                        this.entityFormFields = record['response']['formfields'];
                    }
                    this.formfields = _.cloneDeep(this.entityFormFields);

                    this.entityrecordid = selectedEntityRecord.id;
                    this.entityRecord.id = selectedEntityRecord.id;
                    this.initialFormData = _.cloneDeep(this.entityRecord);
                    this.populateformfields();
                    this.editModal.show();
                } else {
                    console.log('ERROR - Loading Record ' + selectedEntityRecord.id);
                    this.notify('error', 'Record', 'Not Loaded; Please refresh');
                }
            }));
    }

    public hideEditModal(): void {
        this.resetForm();
        this.editModal.hide();
    }

    populateformfields() {
        this.formfields.forEach(ff => {
            this.populateFormGroup(ff);
        });
    }

    populateFormGroup(formgroup) {
        if (formgroup.type === 'repeatedsection') {
            formgroup.templateOptions['parentmodel'] = this.initialFormData;
        } else if (!formgroup.type && Array.isArray(formgroup.fieldGroup) && formgroup.fieldGroup.length > 0) {
            formgroup.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        } else if (!formgroup.type && formgroup.fieldArray
            && Array.isArray(formgroup.fieldArray.fieldGroup)
            && formgroup.fieldArray.fieldGroup.length > 0) {
            formgroup.fieldArray.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        }
    }

    // public showPeekModal(selectedEntityRecord): void {
    //     //Get the record first
    //     this.subscriptions.push(this._EntityrecordApi.findById(selectedEntityRecord.id).subscribe((record: Entityrecord) => {
    //         this.entityRecord = record.data;
    //         this.entityRecord.id = selectedEntityRecord.id;
    //         this.entityrecordid = selectedEntityRecord.id;
    //         this.peekModal.show();
    //     }));

    // }

    // public hidePeekModal(): void {
    //     this.peekModal.hide();
    // }

    public viewEntity(): void {
        //Go to the View entity page
    }

    public updateValidations(formfields) {
        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];
            let fieldType = formField.type;
            let fieldSubType = '';
            let validators = [];

            if (formField.templateOptions.type) {
                fieldSubType = formField.templateOptions.type;
            } else { fieldSubType = 'text'; }

            switch (fieldType) {
                case 'input-field':
                    switch (fieldSubType) {
                        case 'email':
                            validators.push(ValidationService.emailValidator);
                            break;
                        case 'phone':
                            validators.push(ValidationService.phoneValidator);
                            break;
                        case 'default':
                            break;
                    }
                    break;
                case 'geolocation':
                    validators.push(ValidationService.geolocationValidator);
                    break;
                case 'default':
                    break;
            }
            formField['validators'] = { validation: Validators.compose(validators) };

            if (this.parentId && formField.key === "parentId")
                formField.templateOptions.disabled = true;
        }
        return formfields;
    }

    public toggled(): void {
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/display-list/display-list.component.ts